export default function LegalPage({ title, lastUpdated, children }) {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
        <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-3">
          Legal
        </p>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mb-3">{title}</h1>
        <p className="text-sm text-muted-foreground mb-10">Last updated: {lastUpdated}</p>
        <div className="prose prose-invert max-w-none text-secondary-foreground leading-relaxed space-y-6 [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:mt-10 [&_h2]:mb-3 [&_h2]:text-foreground [&_h3]:text-lg [&_h3]:font-medium [&_h3]:mt-6 [&_h3]:mb-2 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1.5 [&_a]:text-primary [&_a]:underline">
          {children}
        </div>
      </div>
    </div>
  );
}